export default __webpack_public_path__ + "static/media/icon-values_3.cdc5050c.svg";